<template>
  <div>
    <v-tooltip bottom>
      <template v-slot:activator="{ on }">
        <v-btn icon class="ml-5" small v-on="on" @click="askScheduler=true">
          <v-icon :color="off ? 'red' : (needHeartbeat ? 'yellow' : 'green')">
            {{ off ? 'mdi-calendar-remove' : (needHeartbeat ? 'mdi-calendar-clock' : 'mdi-calendar-check') }}
          </v-icon>
        </v-btn>
      </template>
      <span>Scheduler {{ off ? 'is Off' : (needHeartbeat ? 'needs heartbeat' : 'is fully active, last heartbeat ' + since + 'm ago') }}</span>
    </v-tooltip>

    <v-tooltip bottom v-if="needHeartbeat">
      <template v-slot:activator="{ on }">
        <v-btn icon class="ml-5" small v-on="on" @click="doHeartbeat()">
          <v-icon color="red">mdi-heart-pulse</v-icon>
        </v-btn>
      </template>
      <span>No heartbeat! Click to resuscitate. Reason: {{ needHeartbeat_reason[1] }}</span>
    </v-tooltip>


    <v-dialog v-model="askScheduler" width="600">
      <v-card class="dialogCard">
        <v-card-title>{{ off ? 'Enable' : 'Disable' }} Scheduler</v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red" text @click="scheduler">Confirm</v-btn>
          <v-btn text @click="askScheduler=false">Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import {mapGetters} from "vuex";

export default {
  name: "SchedulerStatus",

  data() {
    return {
      askScheduler: false,

      group: "deeper" // use deeper group, scheduler always uses deeper group
    }
  },

  computed: {
    needHeartbeat_reason() {
      if (!this.schedulerGroups) {
        return [true, "no scheduler groups"];
      }
      if (!(this.group in this.schedulerGroups)) {
        return [true, `${this.group} not in scheduler groups`];
      }
      if (this.off) {
        return [false, "scheduler is off"];
      }
      if (!this.schedulerGroups[this.group].active) {
        return [true, `${this.group} last heartbeat ${this.since}m ago`];
      }
      return [false, `${this.group} is on, last heartbeat ${this.since}m ago`];
    },
    needHeartbeat() {
      return this.needHeartbeat_reason[0];
    },
    off() {
      if (!this.schedulerGroups) return false;
      if (!(this.group in this.schedulerGroups)) return false;
      if (!this.schedulerGroups[this.group].off) return false;
      return true;
    },
    since() {
      if (!this.schedulerGroups) return "X";
      if (!(this.group in this.schedulerGroups)) return "X";
      return parseInt(this.schedulerGroups[this.group].since);
    },
    since_off() {
      if (!this.schedulerGroups) return "X";
      if (!(this.group in this.schedulerGroups)) return "X";
      return parseInt(this.schedulerGroups[this.group].since_off);
    },

    ...mapGetters([
      'schedulerGroups',
      'activeChatAccountName',
    ])
  },

  methods: {
    doHeartbeat() {
      this.$store.dispatch("postHeartbeat");
    },
    scheduler() {
      this.$store.dispatch("updateScheduler", {
        group: "all",
        off: !this.off
      });

      this.askScheduler = false;
    },
    isActive(scheduler) {
      if (!this.schedulerGroups) return false;
      if (!(scheduler in this.schedulerGroups)) return false;
      if (this.schedulerGroups[scheduler].off) return false;
      return true;
    }
  }
}
</script>

<style scoped>

</style>
